export const style = /*css*/ `
    .p-checkbox-group {
        display: inline-flex;
    }
`;
